/**
 * Resolving free text to an axis value — the pure half of `axes.jsx`.
 *
 * The Price Limits CSV importers read a competitor's export, which
 * names brands and products in words: "Tenerifecar", "PREPAID". Those
 * used to be stored verbatim because the axes were free text. They are
 * ids now, so the words have to be resolved — and a word that resolves
 * to nothing becomes "any" plus a warning, never a silent guess. A
 * price limit scoped to the wrong brand is worse than one scoped to
 * all of them.
 *
 * Moved here from `axes.jsx` verbatim (CU-869fkbjdh) so the CSV parsers
 * that call them can run under `node --test`; `axes.jsx` re-exports
 * them, every caller reads as before.
 */

const norm = (s) => String(s ?? '').trim().toLowerCase()

function resolveIn(options, text) {
	const key = norm(text)
	if (!key) return null
	const byName = options.find(o => norm(o.name) === key)
	if (byName) return Number(byName.code)
	const byId = options.find(o => o.code === key)
	if (byId) return Number(byId.code)
	// A bare number is taken as the id itself: an operator exporting
	// from our own UI gets ids back, not names.
	return /^\d+$/.test(key) ? Number(key) : null
}

export const resolveInsurance = (axes, text) => resolveIn(axes.insurances, text)
export const resolveFranchise = (axes, text) => resolveIn(axes.franchises, text)

/** Prepaid is a boolean, so it reads words rather than a catalogue. */
export function resolvePrepaid(text) {
	const key = norm(text)
	if (!key) return null
	if (['prepaid', 'pp', 'pre', '1', 'true', 'yes'].includes(key)) return true
	if (['postpaid', 'non prepaid', 'non-prepaid', 'post', 'pp0',
	     '0', 'false', 'no'].includes(key)) return false
	return null
}
